import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

// Disable React DevTools in production builds
// if (process.env.NODE_ENV === 'production') {
//   // Method 1: Disable DevTools hook safely
//   if (typeof window !== 'undefined' && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
//     try {
//       // Try to disable existing hook methods
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot = null;
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount = null;
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.isDisabled = true;
      
//       // Clear existing renderers if they exist
//       if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers) {
//         window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers.clear();
//       }
      
//       // Override methods safely
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot = () => {};
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount = () => {};
      
//       console.log('🔒 React DevTools disabled for production');
//     } catch (error) {
//       console.warn('Could not fully disable React DevTools:', error.message);
//     }
//   } else if (typeof window !== 'undefined') {
//     // Method 2: Create disabled hook if it doesn't exist
//     try {
//       window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = {
//         isDisabled: true,
//         supportsFiber: true,
//         inject: () => {},
//         onCommitFiberRoot: () => {},
//         onCommitFiberUnmount: () => {},
//         renderers: new Map(),
//       };
//       console.log('🔒 React DevTools hook created and disabled');
//     } catch (error) {
//       console.warn('Could not create disabled React DevTools hook:', error.message);
//     }
//   }
// }

// Handle production routing - prevent 404 on page reload
// This ensures the app handles client-side routing properly in production
const root = ReactDOM.createRoot(document.getElementById("root"));

// Error boundary component for production routing issues
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App routing error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '2rem', 
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif'
        }}>
          <h2>Application Error</h2>
          <p>The application failed to load. Please refresh the page.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ErrorBoundary>
);